import { Button, ButtonGroup, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
  return {
    outlinedPrimary: {
      background: theme.palette.background.paper,
    },
  }
})

const ScoirApplyButtonToggle = ({
  hasApplyFocus,
  onChangeApplyFocus,
}: {
  hasApplyFocus: boolean
  onChangeApplyFocus: (isFocused: boolean) => void
}) => {
  const classes = useStyles()
  return (
    <>
      <Typography
        variant="srOnly"
        id="filter-applicant-table-aria"
      >
        filter applicant table
      </Typography>
      <ButtonGroup
        color="primary"
        fullWidth
      >
        <Button
          variant={hasApplyFocus ? 'outlined' : 'contained'}
          onClick={!hasApplyFocus ? undefined : () => onChangeApplyFocus(false)}
          classes={{ outlinedPrimary: classes.outlinedPrimary }}
          aria-describedby="filter-applicant-table-aria"
        >
          All Methods
        </Button>
        <Button
          variant={hasApplyFocus ? 'contained' : 'outlined'}
          onClick={hasApplyFocus ? undefined : () => onChangeApplyFocus(true)}
          classes={{ outlinedPrimary: classes.outlinedPrimary }}
          aria-describedby="filter-applicant-table-aria"
        >
          Scoir
        </Button>
      </ButtonGroup>
    </>
  )
}

export default ScoirApplyButtonToggle
